import { render, staticRenderFns } from "./ExamPackagePaperDetail.vue?vue&type=template&id=9adde874&scoped=true"
import script from "./ExamPackagePaperDetail.vue?vue&type=script&lang=js"
export * from "./ExamPackagePaperDetail.vue?vue&type=script&lang=js"
import style0 from "./ExamPackagePaperDetail.vue?vue&type=style&index=0&id=9adde874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9adde874",
  null
  
)

export default component.exports